const WORDS = ["Hospitals", "Diagnostic Labs", "Insurers & TPAs", "Clinicians", "Pharmacies", "Home Care Teams"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`font-display font-extrabold tracking-tight text-5xl sm:text-7xl lg:text-8xl px-6 sm:px-10 ${i % 2 ? "outline-text" : "text-[#14083E]"}`}>{w}</span>
        <span className="h-4 w-4 sm:h-6 sm:w-6 rounded-full bg-brand-gradient shrink-0" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section className="relative py-14 sm:py-20 bg-[#FAFAFC] overflow-hidden border-y border-[#14083E]/10" data-testid="services-marquee" aria-label="Our services">
      <div className="flex w-max marquee-track">
        <Row /><Row />
      </div>
    </section>
  );
}
